import {
  Typography,
  Button,
  Row,
  Col,
  Space,
  Divider,
  Image,
  Spin,
  Badge,
  Card,
} from "antd";
import { useNavigate, useParams } from "react-router-dom";
import {
  ArrowLeftOutlined,
  CheckCircleFilled,
  HeartFilled,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../../redux/slices/cartSlice";
import { useEffect, useState } from "react";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { Helmet } from "react-helmet";
import { getProject } from "../../../api/projects.module";

const { Paragraph, Text } = Typography;
function SingleProject() {
  const [project, setProject] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart.value);
  const { id } = useParams();
  const checkProject = async () => {
    try {
      const dt = await getProject(id);
      if (dt) {
        setProject(dt);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    checkProject();
  }, [id]);
  return (
    <div style={{ padding: "1rem" }}>
      <Helmet>
        <title>{`Buy ${project.title} from Jamir store`}</title>
        <meta name="description" content={project.description} />
      </Helmet>
      <ArrowLeftOutlined onClick={() => navigate(-1)} />
      <Divider dashed />
      {!project ? (
        <Paragraph style={{ textAlign: "center" }}>
          <Spin size={45} /> Loading ...
        </Paragraph>
      ) : (
        <>
          <Row
            gutter={12}
            style={{ background: "#ffffff", padding: "1rem 0.5rem" }}
          >
            <Col sm={24} md={8}>
              <div>
                <ImageGallery
                  items={project.images.map((d) => ({
                    original: d,
                    thumbnail: d,
                  }))}
                  renderImage={(props) => (
                    <div className="image-gallery-image-container">
                      <img {...props} className="image-gallery-image" />
                    </div>
                  )}
                  renderThumb={(props) => (
                    <div className="image-gallery-thumbnail-container">
                      <img {...props} className="image-gallery-thumbnail" />
                    </div>
                  )}
                  autoPlay={true}
                  lazyLoad={true}
                  showNav={false}
                  showPlayButton={false}
                  showBullets={false}
                  thumbnailPosition="bottom"
                />
              </div>
            </Col>
            <Col
              sm={24}
              md={9}
              style={{
                border: "1px solid #0c6f8d20",
                borderRadius: "5px",
                margin: "0.2rem",
                padding: "0.5rem 1rem",
              }}
            >
              <Paragraph strong style={{ padding: "1rem 0", margin: 0 }}>
                <Text style={{ fontSize: "18px", color: "#0c6f8d" }}>
                  {project.title}
                </Text>
              </Paragraph>
              <Paragraph
                style={{ fontSize: "14px", color: "#424141", margin: 0 }}
                ellipsis={{
                  rows: 3,
                  expandable: true,
                  symbol: "read more",
                }}
              >
                {project.description}
              </Paragraph>

              <Paragraph
                style={{
                  fontSize: "16px",
                  paddingTop: "1rem",
                  margin: 0,
                }}
                strong
              >
                USD $ {project.price?.toLocaleString()}.0{" "}
                <Text style={{ color: "gray" }}>
                  <del>USD $ {project.price + project.price * 0.1}</del>{" "}
                </Text>
              </Paragraph>

              <Paragraph style={{ padding: "1rem 0", margin: 0 }}>
                <Space>
                  {cart.find((x) => x.id === id) ? (
                    <Button type="primary" danger>
                      Added to Cart
                    </Button>
                  ) : (
                    <Button
                      type="primary"
                      onClick={() => dispatch(addToCart(project))}
                    >
                      Add to Cart
                    </Button>
                  )}
                  <Button type="dashed">Live Demo</Button>
                </Space>
              </Paragraph>
            </Col>
            <Col
              sm={24}
              xs={24}
              md={6}
              style={{
                border: "1px solid #0c6f8d20",
                borderRadius: "5px",
                margin: "0.2rem",
                padding: "0.5rem 1rem",
              }}
            >
              <Paragraph
                strong
                style={{
                  padding: "1rem 0",
                  fontSize: "16px",
                  borderBottom: "1px dotted #ccc",
                }}
              >
                Features
              </Paragraph>
              <Paragraph>
                {project.features.length > 0 && (
                  <>
                    {project.features.map((x) => (
                      <Paragraph
                        key={x}
                        style={{
                          // width: "24%",
                          boxSizing: "border-box",
                          padding: 0,
                          margin: "2px 0",
                        }}
                      >
                        <Space size={5}>
                          <CheckCircleFilled style={{ color: "#1890ff" }} />
                          <Text style={{ color: "#888" }}>{x} </Text>
                        </Space>
                      </Paragraph>
                    ))}
                  </>
                )}
              </Paragraph>
            </Col>
          </Row>
          <Divider dashed />
          <Paragraph strong style={{ fontSize: "16px" }}>
            Customer comments
          </Paragraph>
          <Divider dashed />
          <Paragraph strong style={{ fontSize: "16px" }}>
            Related products
          </Paragraph>
        </>
      )}
    </div>
  );
}

export default SingleProject;
